
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgxSelectModule } from 'ngx-select-ex';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RouterModule, Routes } from '@angular/router';
import { BusinessInfoComponent } from './Pages/business-info/business-info.component';
import { DataService } from '../services/data.service';
import { BusinessInfoService } from './POSServices/Business/business-info.service';
import { CustomerComponent } from './Pages/customer/customer.component';
import { CustomerListComponent } from './Pages/customer-list/customer-list.component';
import { EmployeeComponent } from './Pages/employee/employee.component';
import { EmployeeListComponent } from './Pages/employee-list/employee-list.component';
import { OrderDetailComponent } from './Pages/order-detail/order-detail.component';
import { OrderComponent } from './Pages/POSSetup/order/order.component';
import { OrderManagementComponent } from './Pages/order-management/order-management.component';
import { POSHomeComponent } from './Pages/poshome/poshome.component';
import { BusinessHoursComponent } from './Pages/POSSetup/business-hours/business-hours.component';
import { BusinessHoursListComponent } from './Pages/POSSetup/business-hours-list/business-hours-list.component';
import { ItemComponent } from './Pages/POSSetup/item/item.component';
import { ItemCategoryComponent } from './Pages/POSSetup/item-category/item-category.component';
import { ItemCategoryListComponent } from './Pages/POSSetup/item-category-list/item-category-list.component';
import { OrdersComponent } from './Pages/orders/orders.component';
import { OrderListComponent } from './Pages/POSSetup/order-list/order-list.component';
import { OrderReceiptComponent } from './Pages/POSSetup/order-receipt/order-receipt.component';
import { OrderReceiptListComponent } from './Pages/POSSetup/order-receipt-list/order-receipt-list.component';
import { OrderRegisterComponent } from './Pages/POSSetup/order-register/order-register.component';
import { OrderTypeComponent } from './Pages/POSSetup/order-type/order-type.component';
import { OrderTypeLisComponent } from './Pages/POSSetup/order-type-lis/order-type-lis.component';
import { PaymentComponent } from './Pages/POSSetup/payment/payment.component';
import { PaymentListComponent } from './Pages/POSSetup/payment-list/payment-list.component';
import { PaymentReceiptComponent } from './Pages/POSSetup/payment-receipt/payment-receipt.component';
import { TaxFeeComponent } from './Pages/POSSetup/tax-fee/tax-fee.component';
import { TaxFeeListComponent } from './Pages/POSSetup/tax-fee-list/tax-fee-list.component';
import { TenderComponent } from './Pages/POSSetup/tender/tender.component';
import { TenderListComponent } from './Pages/POSSetup/tender-list/tender-list.component';
import { TipsComponent } from './Pages/POSSetup/tips/tips.component';
import { TipsListComponent } from './Pages/POSSetup/tips-list/tips-list.component';
import { CustomerService } from './POSServices/Customers/customer.service';
import { EmployeeService } from './POSServices/Employees/employee.service';
import { ItemServiceService } from './POSServices/Setup/item-service.service';
import { ItemService } from './POSServices/Setup/item.service';
import { OrdeRegsiterService } from './POSServices/Setup/orde-regsiter.service';
import { OrderService } from './POSServices/Setup/order.service';
import { PaymentService } from './POSServices/Setup/payment.service';
import { TenderTipTaxService } from './POSServices/Setup/tender-tip-tax.service';
import { ItemListComponent } from './Pages/POSSetup/item-list/item-list.component';
// import { // Ng2TableModule, } from 'ng2-table/ng2-table';



import { CustomerViewComponent } from './Pages/customer-view/customer-view.component';
import { PaymentViewComponent } from './Pages/POSSetup/payment-view/payment-view.component';
import { OrderViewComponent } from './Pages/POSSetup/order-view/order-view.component';
import { TaxFeeViewComponent } from './Pages/POSSetup/tax-fee-view/tax-fee-view.component';
import { TenderViewComponent } from './Pages/POSSetup/tender-view/tender-view.component';
import { EmployeeViewComponent } from './Pages/employee-view/employee-view.component';
import { TipsViewComponent } from './Pages/POSSetup/tips-view/tips-view.component';
import { BusinessHoursViewComponent } from './Pages/POSSetup/business-hours-view/business-hours-view.component';
import { ItemCategoryViewComponent } from './Pages/POSSetup/item-category-view/item-category-view.component';
import { OrderReceiptViewComponent } from './Pages/POSSetup/order-receipt-view/order-receipt-view.component';
import { OrderTypeViewComponent } from './Pages/POSSetup/order-type-view/order-type-view.component';
import { ItemViewComponent } from './Pages/POSSetup/item-view/item-view.component';
import { LoginComponent } from './Pages/Poslogin/login/login.component';
import { TransactionviewdetailsComponent } from './Pages/PosTransactiondetails/transactionviewdetails/transactionviewdetails.component';
import { GuideComponent } from './Pages/guide/guide.component';
import { MobileAppdownloadComponent } from './Pages/mobile-appdownload/mobile-appdownload.component';
import { QRCodeModule } from 'angularx-qrcode';
import { SetupbusinessComponent } from './Pages/setupbusiness/setupbusiness.component'; 
import { AccountingService } from './POSServices/Accounting/accounting.service'; 
const routes: Routes = [

  { path: 'poslogin', component: LoginComponent },
  { path: 'pos', component: POSHomeComponent },
  { path: 'businessinfo', component: BusinessInfoComponent },
  { path: 'customer/new', component: CustomerComponent },
  { path: 'customer/manage', component: CustomerListComponent },
  { path: 'customer/view', component: CustomerViewComponent },
  { path: 'Employee/new', component: EmployeeComponent },
  { path: 'Employee/view', component: EmployeeViewComponent },
  { path: 'businesshour/new', component: BusinessHoursComponent },
  { path: 'businesshour/view', component: BusinessHoursViewComponent },
  { path: 'item/new', component: ItemComponent },
  { path: 'item/view', component: ItemViewComponent },
  { path: 'category/new', component: ItemCategoryComponent },
  { path: 'category/view', component: ItemCategoryViewComponent },
  { path: 'taxfee/new', component: TaxFeeComponent },
  { path: 'taxfee/view', component: TaxFeeViewComponent },
  { path: 'payment/new', component: PaymentComponent },
  { path: 'paymentrecipt/new', component: PaymentReceiptComponent },
  { path: 'tip/new', component: TipsComponent },
  { path: 'tender/new', component: TenderComponent },
  { path: 'employee/manage', component: EmployeeListComponent },
  { path: 'businesshour/manage', component: BusinessHoursListComponent },
  { path: 'item/manage', component: ItemListComponent },
  { path: 'category/manage', component: ItemCategoryListComponent },
  { path: 'payment/manage', component: PaymentListComponent },
  { path: 'taxfee/manage', component: TaxFeeListComponent },
  { path: 'tender/manage', component: TenderListComponent },
  { path: 'tender/view', component: TenderViewComponent },
  { path: 'tips/manage', component: TipsListComponent },
  { path: 'tips/view', component: TipsViewComponent },
  { path: 'payment/view', component: PaymentViewComponent },
  // { path: 'item/new2', component: AddnewItemsComponent},
  // { path: 'supplier/add', component: AddSupplierComponent},
  // { path: 'voucher/add', component: VoucherComponent},


  { path: 'transactiondetails', component: TransactionviewdetailsComponent },
  { path: 'order/new', component: OrderComponent },
  { path: 'order/view', component: OrderViewComponent },
  { path: 'order/manage', component: OrderListComponent },
  { path: 'orderreceipt/new', component: OrderReceiptComponent },
  { path: 'orderreceipt/view', component: OrderReceiptViewComponent },
  { path: 'orderreceipt/manage', component: OrderReceiptListComponent },
  { path: 'orderregister', component: OrderRegisterComponent },
  { path: 'ordertype/new', component: OrderTypeComponent },
  { path: 'ordertype/view', component: OrderTypeViewComponent },
  { path: 'ordertype/manage', component: OrderTypeLisComponent },
  { path: 'orderdetails/view', component: OrderDetailComponent },
  { path: 'orders/new', component: OrdersComponent },
  { path: 'orders/manage', component: OrderManagementComponent },
  { path: 'ordertype/edit', component: OrderTypeComponent },
  { path: 'orderreceipt/edit', component: OrderReceiptComponent },
  { path: 'order/edit', component: OrderComponent },
  { path: 'guide', component: GuideComponent },
  { path: 'pos/download', component: MobileAppdownloadComponent },
  { path: 'pos/setup', component: SetupbusinessComponent },
];


@NgModule({
  declarations: [
    LoginComponent,
    BusinessInfoComponent,
    CustomerComponent,
    CustomerListComponent,
    EmployeeComponent,
    EmployeeListComponent,
    OrderDetailComponent,
    OrderComponent,
    OrderManagementComponent,
    POSHomeComponent,
    BusinessHoursComponent,
    BusinessHoursListComponent,
    ItemComponent,
    ItemCategoryComponent,
    ItemCategoryListComponent,
    OrdersComponent,
    OrderListComponent,
    OrderReceiptComponent,
    OrderReceiptListComponent,
    OrderRegisterComponent,
    OrderTypeComponent,
    OrderTypeLisComponent,
    PaymentComponent,
    PaymentListComponent,
    PaymentReceiptComponent,
    TaxFeeComponent,
    TaxFeeListComponent,
    TenderComponent,
    TenderListComponent,
    TipsComponent,
    TipsListComponent,
    ItemListComponent,

    EmployeeViewComponent,
    CustomerViewComponent,
    PaymentViewComponent,
    ItemViewComponent,
    OrderReceiptViewComponent,
    OrderViewComponent,
    TaxFeeViewComponent,
    TenderViewComponent,
    ItemCategoryViewComponent,
    BusinessHoursViewComponent,
    OrderTypeViewComponent,
    TipsViewComponent,
    LoginComponent,
    TransactionviewdetailsComponent,
    GuideComponent,
    MobileAppdownloadComponent,
    SetupbusinessComponent,
    //AddnewItemsComponent, AddSupplierComponent, VoucherComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule.forChild(routes),
    NgxSelectModule,
    NgxDatatableModule,
    // Ng2TableModule,,
    QRCodeModule



  ],
  providers: [
    DataService,
    BusinessInfoService,
    CustomerService,
    EmployeeService,
    ItemService,
    OrdeRegsiterService,
    OrderService,
    PaymentService,
    TenderTipTaxService,
    AccountingService
  ],
  exports: [
    RouterModule
  ]
})
export class POSModule { }

